import React from 'react';
export default class ModernResumeReference extends React.Component{

    getResumeBlock(data, index){
        let title = [];
        if (data.name){
            title.push(<span key="a" data-v-37c786be="">{data.name}</span>)
        }

        if (data.title){
            title.push(<span key="b" data-v-37c786be="">{data.title}</span>)
        }

        if (data.companyName){
            title.push(<span key="c" data-v-37c786be="">{data.companyName}</span>)
        }

        let titleFinal = [];
        for(let i = 0; i < title.length; i++){
            titleFinal.push(title[i]);
            if(i + 1 < title.length){
                titleFinal.push(<span key={i} data-v-37c786be="" className="comma">, </span>)
            }
        }

        return  <div data-v-37c786be="" className="section-item" key={index}>
                    <div data-v-37c786be="" className="section-title">
                        {titleFinal}
                    </div>
                    {data.email && <div data-v-37c786be="" className="section-description">{data.email}</div>}
                    {data.phone && <div data-v-37c786be="" className="section-description">{data.phone}</div>}
                    {data.address && <div data-v-37c786be="" className="section-description">{data.address}</div>}
                </div>
    }

    render(){
        return  <div data-v-37c786be="" className="section">
					<div data-v-37c786be="" className="section-left">
						<div data-v-37c786be="" className="section-headline">{this.props.title}</div>
					</div>
					<div data-v-37c786be="" className="section-right">
						{this.props.data.map((item, index) => {
							return this.getResumeBlock(item, index);
						})}
					</div>
                </div>

    }
}